import { useCallback, useEffect, useRef, useState } from 'react';
import { pick } from 'ramda';
import { useDispatch } from 'react-redux';
import { showTimeIsFlyingPopupAction } from 'js/components/popups/TimeIsFlying';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

export const useTimeIsFlyingNotification = () => {
    const timeIsFlyingTimer = useRef(-1);

    const {
        timeFlyingPeriod,
        timeIsFlyingWebContent
    } = useAppSelector(pick(['timeFlyingPeriod', 'timeIsFlyingWebContent']));
    const { isLoggedIn, sessionStartTime } = useUserSelector(pick(['isLoggedIn', 'sessionStartTime']));
    const [sessionNotificationEnabled, setSessionNotificationEnabled] = useState(true);
    const dispatch = useDispatch();

    /**
     * Should show message every `timeFlyingPeriod` minutes
     */
    const startTimeIsFlyingNotification = useCallback(() => {
        const periodInMs = timeFlyingPeriod * 60 * 1000;
        const expirationTime = periodInMs - (Date.now() - sessionStartTime) % periodInMs;

        const showNotification = () => {
            dispatch(showTimeIsFlyingPopupAction({
                disableNotification: () => setSessionNotificationEnabled(false),
                onClose: () => {
                    timeIsFlyingTimer.current = window.setTimeout(showNotification, periodInMs);
                }
            }));
        };

        if (sessionNotificationEnabled && timeIsFlyingWebContent) {
            timeIsFlyingTimer.current = window.setTimeout(showNotification, expirationTime);
        }
    }, [sessionNotificationEnabled, dispatch, sessionStartTime, timeFlyingPeriod, timeIsFlyingWebContent]);

    useEffect(() => {
        window.clearTimeout(timeIsFlyingTimer.current);

        if (isLoggedIn && Number(timeFlyingPeriod) > 0) {
            startTimeIsFlyingNotification();
        }
    }, [
        isLoggedIn,
        startTimeIsFlyingNotification,
        timeFlyingPeriod
    ]);
};
